import { getProductDropdownLCA } from "../apis/Bonsai/productDropdownApi";

// Global cache for Bonsai dropdown data
class BonsaiCache {
  constructor() {
    this.cache = null;
    this.isLoading = false;
    this.loadingPromise = null;
    this.listeners = new Set();
  }

  // Get cached data or start loading if not cached
  async getData() {
    // Return cached data if available
    if (this.cache) {
      return this.cache;
    }

    // If already loading, return the existing promise
    if (this.isLoading && this.loadingPromise) {
      return this.loadingPromise;
    }

    // Start loading
    this.isLoading = true;
    this.loadingPromise = this.loadData();

    return this.loadingPromise;
  }

  // Load data from API
  async loadData() {
    return new Promise((resolve, reject) => {
      getProductDropdownLCA({
        setDropdownData: (data) => {
          this.cache = data;
          this.isLoading = false;
          this.loadingPromise = null;

          // Notify all listeners
          this.listeners.forEach((callback) => callback(data));

          resolve(data);
        },
      });
    });
  }

  // Preload data (fire and forget)
  preload() {
    if (!this.cache && !this.isLoading) {
      this.getData().catch((error) => {
        console.error("Failed to preload Bonsai data:", error);
        this.isLoading = false;
        this.loadingPromise = null;
      });
    }
  }

  // Subscribe to data updates
  subscribe(callback) {
    this.listeners.add(callback);

    // If data is already available, call immediately
    if (this.cache) {
      callback(this.cache);
    }

    // Return unsubscribe function
    return () => {
      this.listeners.delete(callback);
    };
  }

  // Clear cache (useful for testing or if data needs refresh)
  clear() {
    this.cache = null;
    this.isLoading = false;
    this.loadingPromise = null;
  }

  // Check if data is available
  isDataAvailable() {
    return this.cache !== null;
  }

  // Check if currently loading
  isLoading() {
    return this.isLoading;
  }
}

// Export singleton instance
export const bonsaiCache = new BonsaiCache();
export default bonsaiCache;
